<script setup>
  import { onMounted, ref, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import { apiService } from '@/services/api'
  import { useDialogStore } from '@/stores/dialogStore'
  import { useUserStore } from '@/stores/userStore'
  import { convertToHalfWidthNumber } from '@/components/logics/Util'
  import Webpass from '@laragear/webpass'
  import FooterNoneLogin from '@/components/FooterNoneLogin.vue'

  const router = useRouter()

  const dialogStore = useDialogStore()
  const userStore = useUserStore()

  const showPassword = ref(false)

  // フォーム用データ
  const form = ref(null)
  const formData = ref({
    email: '',
  })

  // パスワードリセットメール送信
  const sendResetPasswordMail = async () => {
    try {
      const response = await apiService.post('api/password/email', formData.value)
      dialogStore.showMessageDialog('メール送信完了', response.message)
    } catch (error) {}
  }
</script>

<template>
  <header></header>
  <main class="login-main">
    <div class="login-content">
      <form @submit.prevent="sendResetPasswordMail" ref="form" method="post">
        <h1><img class="logo" src="@/assets/img/login_logo.svg" alt="ディーモ for 社労士" /></h1>
        <h2>パスワード再設定</h2>
        <div class="form-grid">
          <div class="login-input">
            <label>メールアドレス</label>
            <input type="text" name="email" id="email" v-model="formData.email" required />
          </div>
          <button class="input-submit" type="submit" :disabled="formData.email == ''">メール送信</button>
        </div>
      </form>
    </div>
  </main>
  <FooterNoneLogin />
</template>

<style lang="less" scoped>
  .forgot-password {
    text-align: center;
    color: var(--active-color);
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
    transition: opacity 0.3s;
  }
</style>
